export default {
    name: 'ProdottoIcone',
    props: ['prodotto'],
    data: () => {
        return {
        }
    }
}
